// ** React Imports
// ** Core Layout Import
// !Do not remove the Layout import
import Layout from '@layouts/HorizontalLayout'
import { SectionOutlet } from '@components/routes/SectionOutlet'

// ** Menu Items Array
import navigation from '@src/navigation/horizontal'

const HorizontalLayout = (props) => {
  // const [menuData, setMenuData] = useState([])
  // ** For ServerSide navigation
  // useEffect(() => {
  //   axios.get(URL).then(response => setMenuData(response.data))
  // }, [])

  return (
    <Layout menuData={navigation} {...props}>
      <SectionOutlet />
    </Layout>
  )
}

export default HorizontalLayout
